﻿import {Controller} from "./helpers/controller";

export class SharePageControl extends Controller {
    
    private title: string = '';
    constructor(element: HTMLElement) {
        super(element);
        
        $(element).on('click', async () => {
           
                this.title = $(element).data().sharepage;

                await navigator.share({
                    title: this.title,
                    url: window.location.href
                });
                
            
        })
    }
}